<template>
  <div class="page-content">
    <b-row>
      <b-col md="10">
        <page-breadcrumb title="Reward" class="mb-3" />
      </b-col>
    </b-row>
    <b-media>
      <section class="py-3">
        <b-card>
          <config-table :config="config" @getConfig="getConfig" />
        </b-card>
      </section>
    </b-media>
    <b-pagination
      class="mt-auto"
      pills
      size="lg"
      align="center"
      v-model="current_page"
      :total-rows="total_items"
      :per-page="items_perpage"
    />
  </div>
</template>

<script>
import configService from "../../../config/service";
import { GOGA_RANK_REWARD_CONFIG, MODULE_CATEGORY } from '../constants'
import ConfigTable from "./_components/ConfigTable.vue";

export default {
  components: {
    ConfigTable,
  },
  data() {
    return {
      current_page: 1,
      total_items: 0,
      items_perpage: 50,
      config: {},
    };
  },
  created() {
    this.getConfig()
  },
  methods: {
    async getConfig() {
      this.config = await configService.getByKey({ key: GOGA_RANK_REWARD_CONFIG.key }, { default_data: GOGA_RANK_REWARD_CONFIG.default_data, category: MODULE_CATEGORY })
    },
  },
};
</script>
<style lang="scss" scoped>
.media-body {
  overflow: auto;
}
</style>